/**
 * Customer and third-party error patterns
 * Extracted from constants.ts to reduce file size
 */

import type { UserFriendlyError } from "../types";

/**
 * Customer/Third-party error patterns
 */
export const customerErrorPatterns: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	{
		pattern: /SMS sending failed/i,
		message: (match: RegExpMatchArray) => ({
			title: "SMS sending failed",
			message: (match.input ?? match[0] ?? "SMS sending failed").trim(),
			canRetry: true,
		}),
	},
	{
		pattern: /customer not found/i,
		message: {
			title: "Client introuvable",
			message: "Aucun client ne correspond à ces informations.",
			canRetry: false,
		},
	},
	{
		pattern: /totp.*expired|code.*expired|code.*expiré|code non trouvé ou expiré/i,
		message: {
			title: "Code expiré",
			message: "Le code de vérification a expiré. Veuillez en demander un nouveau.",
			canRetry: true,
		},
	},
	{
		pattern: /invalid.*code|wrong.*code|code invalide/i,
		message: {
			title: "Code incorrect",
			message: "Le code de vérification saisi est incorrect. Veuillez réessayer.",
			canRetry: true,
		},
	},
	{
		pattern: /invalid password|wrong password/i,
		message: {
			title: "Mot de passe incorrect",
			message: "Le mot de passe saisi est incorrect.",
			canRetry: true,
		},
	},
	{
		pattern: /Plusieurs notaires invités pour ce bureau/i,
		message: (match: RegExpMatchArray) => ({
			title: "Impossible d'enregistrer la note",
			message: (match.input ?? match[0] ?? "").trim(),
			canRetry: false,
		}),
	},
];

